export const getName = (formData: any) => {
    if (formData.personal_information) {
        return `${formData?.personal_information?.firstName} ${formData?.personal_information?.surname}`
    }
    if (formData.authorised_representative) {
        return `${formData?.authorised_representative?.firstName} ${formData?.authorised_representative?.surname}`
    }
    return null;
}
